<script>
import simplebar from "simplebar-vue";
import JsonForm from "../layouts/updated_form.vue";
import api from "../../api";
import Swal from "sweetalert2";

export default {
  props: {
    schema: {},
    category: {}
  },
  components:  {simplebar, JsonForm},
  data() {
    return {
      selectedTab: '',
      side_panel_formData: {},
      form_formData: null,
      old_form_formData: {},
      selectedItem: {},
      location_list: [],
      selectedGroup: '',
      selectedSubgroup: '',
      selectedLocation: {},
      list_length: 0,
      member_list: [],
      form_formData_locations: [],
      form_formData_member_group: {},
      form_formData_member_subgroup: {}
    };
  },
  computed: {
    currentFormData() {
      return this.$store.getters.currentFormData;
    },
    oldFormData() {
      return this.$store.getters.oldFormData;
    },
  },
  methods: {
    async selectedTabFn(val) {
      if(this.selectedTab != val) {
        this.form_formData = {}
        this.old_form_formData = JSON.stringify(this.form_formData)
        this.$store.commit('updateOldFormData', JSON.parse(this.old_form_formData))
        this.$store.commit('updateCurrentFormData', this.form_formData)
      }
      this.selectedTab = val;
      this.$emit('selected-tab', this.selectedTab);
      if(this.selectedTab == "Locations") {
        var temp = this.schema.tabs.filter(tab => tab.name == "Locations")[0].side_panel.select_a_day.options[0];
        this.selectedItemFn(temp)
      }
      else if(this.selectedTab == "Team") {
        const teamTab = this.schema.tabs.find(tab => tab.name == "Team");
        // if(this.category.additionalProp1.groups && this.category.additionalProp1.groups.length > 0) {
          teamTab.side_panel.groups.options = this.category.additionalProp1.groups;
        // }
        // else {
        //   teamTab.side_panel.groups.options = [
        //     { title: "Doctor" },
        //     { title: "Nurses" },
        //     { title: "Management" },
        //     { title: "Admin" },
        //     { title: "Commmunity Wellbeing" }
        //   ];
        // }
        // if(this.category.additionalProp1.subgroups) {
          // teamTab.side_panel.subgroups.options = this.category.additionalProp1.subgroups;
        // }
        // else {
        //   teamTab.side_panel.subgroups.options = [
        //     { title: "Heading 1" },
        //     { title: "Heading 2" }
        //   ];
        // }

        try {
          const response = await api.get(`/api/categories/${this.category.id}/pages`);
          this.member_list = response.data.sort((a, b) => a.additionalProp1.position - b.additionalProp1.position)
        } catch (error) {
          console.log(error);
        }
        

        this.selectedGroupFn(teamTab.side_panel.groups.options[0])
        // this.selectedSubgroupFn(teamTab.side_panel.subgroups.options[0])

      }
      else if(this.selectedTab == "Content") {
        this.form_formData = {};
        this.form_formData.page_description = this.category.additionalProp1.text ? this.category.additionalProp1.text : '';
      }
      else if(this.selectedTab == "Description") {
        if(this.category.additionalProp1.description) {
          this.form_formData.description = this.category.additionalProp1.description.text;
        }
        if(this.category.additionalProp1.related_information) {
          this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].form.related_information.options = this.category.additionalProp1.related_information;
        }
        else {
          this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].form.related_information.options = [
            {
              name: 'Practice Team',
              value: false
            },
            {
              name: 'Practice Location',
              value: false
            },
            {
              name: 'GP & Nurse Availability',
              value: false
            },
            {
              name: 'When we are Closed',
              value: false
            },
            {
              name: 'Contact Us ',
              value: false
            },
          ];
        }

      }
      else if(this.selectedTab == "Regular Hours") {
        if(this.selectedLocation) {
          this.selectedLocationFn(this.selectedLocation)
        } else {
          let first_loc = this.schema.tabs.filter(tab => tab.name == "Regular Hours")[0].side_panel.location.options[0];
          this.selectedLocationFn(first_loc)
        }
        this.schema.tabs.filter(tab => tab.name == "Regular Hours")[0].side_panel.days.options = [];
        this.old_form_formData = '';
        this.form_formData = {};
        this.$store.commit('updateCurrentFormData', this.form_formData)
        this.$store.commit('updateOldFormData', JSON.parse(this.old_form_formData))
        if('location' in this.side_panel_formData) {
          delete this.side_panel_formData['location']
        }
      }
      else if(this.selectedTab == "Practice Closure") {
        if(this.selectedLocation) {
          this.selectedLocationFn(this.selectedLocation)
        } else {
          let first_loc = this.schema.tabs.filter(tab => tab.name == "Practice Closure")[0].side_panel.location.options[0];
          this.selectedLocationFn(first_loc)
        }

        this.schema.tabs.filter(tab => tab.name == "Practice Closure")[0].side_panel.dates.options = [];
        this.old_form_formData = '';
        this.form_formData = {};
        this.$store.commit('updateCurrentFormData', this.form_formData)
        this.$store.commit('updateOldFormData', JSON.parse(this.old_form_formData))
        if('location' in this.side_panel_formData) {
          delete this.side_panel_formData['location']
        }
      }
      else if(this.selectedTab == "News") {
        this.list_length = this.schema.tabs.filter(tab => tab.name == "News")[0].side_panel.select_a_page.options.length;
        var first_news = this.schema.tabs.filter(tab => tab.name == "News")[0].side_panel.select_a_page.options[0];
        console.log(first_news)
        this.selectedItemFn(first_news)      
      }
      else if(this.selectedTab == "Alerts") {
        this.list_length = this.schema.tabs.filter(tab => tab.name == "Alerts")[0].side_panel.select_a_page.options.length;
        var first_alert = this.schema.tabs.filter(tab => tab.name == "Alerts")[0].side_panel.select_a_page.options[0];
        this.selectedItemFn(first_alert);
      }
      else if(this.selectedTab == "Groups") {
        if(this.schema.tabs.filter(tab => tab.name == "Groups")[0].side_panel.groups.options) {
          this.list_length = this.schema.tabs.filter(tab => tab.name == "Groups")[0].side_panel.groups.options.length;
          var first_group = this.schema.tabs.filter(tab => tab.name == "Groups")[0].side_panel.groups.options[0];
          if(!first_group) {
            first_group = this.category.additionalProp1.groups[0]
          }
          this.selectedItemFn(first_group);
        }
      }
      else if(this.selectedTab == "Permissions") {
        var first_role = this.schema.tabs.filter(tab => tab.name == "Permissions")[0].side_panel.select_a_page.options[this.schema.tabs.filter(tab => tab.name == "Permissions")[0].side_panel.select_a_page.options.length - 1];
        this.selectedItemFn(first_role)      

        for (const key of Object.keys(first_role.permissions)) {
          this.schema.tabs.filter(tab => tab.name == "Permissions")[0].form[key] = {
            type: 'toggle-permissions',
            label: key,
            placeholder: '',
            required: false,
            info: false,
            character_count: 0,
            disabled: false,
            wrapper_class: 'col-4'
          }
        }

      }
    },
    selectedLocationFn(location) {

        this.$emit('selected-location', location);

        if(location.id) {
          this.selectedLocation = location;
          if(this.selectedTab == 'Regular Hours') {
            api.get(`/api/cms/${this.currentCms.id}/categories`)
            .then((response) => {
              var locationCat = response.data.filter(x => x.name == 'Locations')[0];

              api.get(`/api/categories/${locationCat.id}/pages`)
              .then((response2) => {
                var re = response2.data.filter(r => r.id == location.id)[0].additionalProp1.regular_hours;
                var fn = response2.data.filter(r => r.id == location.id)[0].additionalProp1.footnote;
                if(fn) {
                  this.side_panel_formData.footnote = fn;
                }
                else {
                  this.side_panel_formData.footnote = '';
                }
                if(re) {
                  this.schema.tabs.filter(tab => tab.name == "Regular Hours")[0].side_panel.days.options = re;
                }
                else {
                  this.schema.tabs.filter(tab => tab.name == "Regular Hours")[0].side_panel.days.options = [
                    {
                      id: 1,
                      title: 'Monday',
                      status: [
                        {
                          name: 'Closed',
                          value: false
                        },
                        {
                          name: 'Interim Closure',
                          value: true
                        }
                      ],
                      opening_time: '08:00',
                      closing_time: '18:30',
                      second_opening_time: '00:00',
                      second_closing_time: '00:00'
                    },
                    {
                      id: 2,
                      title: 'Tuesday',
                      status: [
                        {
                          name: 'Closed',
                          value: false
                        },
                        {
                          name: 'Interim Closure',
                          value: true
                        }
                      ],
                      opening_time: '08:00',
                      closing_time: '18:30',
                      second_opening_time: '00:00',
                      second_closing_time: '00:00'
                    },
                    {
                      id: 3,
                      title: 'Wednesday',
                      status: [
                        {
                          name: 'Closed',
                          value: false
                        },
                        {
                          name: 'Interim Closure',
                          value: true
                        }
                      ],
                      opening_time: '08:00',
                      closing_time: '18:30',
                      second_opening_time: '00:00',
                      second_closing_time: '00:00'
                    },
                    {
                      id: 4,
                      title: 'Thursday',
                      status: [
                        {
                          name: 'Closed',
                          value: false
                        },
                        {
                          name: 'Interim Closure',
                          value: true
                        }
                      ],
                      opening_time: '08:00',
                      closing_time: '18:30',
                      second_opening_time: '00:00',
                      second_closing_time: '00:00'
                    },
                    {
                      id: 5,
                      title: 'Friday',
                      status: [
                        {
                          name: 'Closed',
                          value: false
                        },
                        {
                          name: 'Interim Closure',
                          value: true
                        }
                      ],
                      opening_time: '08:00',
                      closing_time: '18:30',
                      second_opening_time: '00:00',
                      second_closing_time: '00:00'
                    },
                    {
                      id: 6,
                      title: 'Saturday',
                      status: [
                        {
                          name: 'Closed',
                          value: true
                        },
                        {
                          name: 'Interim Closure',
                          value: true
                        }
                      ],
                      opening_time: '08:00',
                      closing_time: '18:30',
                      second_opening_time: '00:00',
                      second_closing_time: '00:00'
                    },
                    {
                      id: 7,
                      title: 'Sunday',
                      status: [
                        {
                          name: 'Closed',
                          value: true
                        },
                        {
                          name: 'Interim Closure',
                          value: true
                        }
                      ],
                      opening_time: '08:00',
                      closing_time: '18:30',
                      second_opening_time: '00:00',
                      second_closing_time: '00:00'
                    }
                  ]
                }

                var firstItem = this.schema.tabs.filter(tab => tab.name == "Regular Hours")[0].side_panel.days.options[0];
                if(firstItem) this.selectedItemFn(firstItem);

              }, (error) => {
                console.log(error);
              });

            }, (error) => {
              console.log(error);
            });
          }
          else if(this.selectedTab == 'Practice Closure') {
            api.get(`/api/categories/${this.category.id}/pages`)
            .then((response) => {
              var date_list = response.data.filter(x => x.additionalProp1.location_id == location.id);
              date_list = date_list.reverse()
              this.schema.tabs.filter(tab => tab.name == 'Practice Closure')[0].side_panel.dates.options = date_list;  
              
              if(!date_list.length) {
                this.form_formData = {};
                this.old_form_formData = JSON.stringify(this.form_formData)
                this.$store.commit('updateCurrentFormData', this.form_formData)
                this.$store.commit('updateOldFormData', JSON.parse(this.old_form_formData))
              }
              var firstItem = date_list[0];
              if(firstItem) {
                this.selectedItemFn(firstItem);
              }
            }, (error) => {
              console.log(error);
            });
          }
        }

    },
    selectedGroupFn(group) {
      // console.log('group', group)
      const teamTab =  this.schema.tabs.find(tab => tab.name == 'Team');

      if(group.id) {
        this.selectedGroup = group;
        this.$emit('selected-group', this.selectedGroup);

        if(group.subgroups.length) {
          teamTab.side_panel.subgroups.options = group.subgroups;
          // this.selectedSubgroupFn(teamTab.side_panel.subgroups.options[0])

          // teamTab.side_panel.members.options = this.member_list.filter(x => x.additionalProp1.group == group.title); 
          // var firstItem = teamTab.side_panel.members.options[0];
          // if(firstItem) {
          //   this.selectedItemFn(firstItem);
          // }
          // else {
          //   this.form_formData = {};
          //   this.old_form_formData = '';
          // }
        }
        else {
          teamTab.side_panel.subgroups.options = [];
        }
          this.selectedSubgroup = null;
          this.$emit('selected-subgroup', this.selectedSubgroup);

          this.form_formData = {};
          this.old_form_formData = JSON.stringify(this.form_formData);

          this.$store.commit('updateOldFormData', JSON.parse(this.old_form_formData))
          this.$store.commit('updateCurrentFormData', this.form_formData)

          teamTab.side_panel.members.options = this.member_list.filter(x => x.additionalProp1.group == group.id && (!x.additionalProp1.subgroup || x.additionalProp1.subgroup == '')); 
          var firstItem = teamTab.side_panel.members.options[0];
          if(firstItem) {
            this.selectedItemFn(firstItem);
          }

      }
    },
    selectedSubgroupFn(subgroup) {
      // var self = this;
      if(subgroup.id && this.selectedGroup.subgroups.some(x => x.id == subgroup.id)
      ) {
        this.selectedSubgroup = subgroup;
        this.$emit('selected-subgroup', this.selectedSubgroup);

        this.form_formData = {};
        this.old_form_formData = JSON.stringify(this.form_formData);

        this.$store.commit('updateOldFormData', JSON.parse(this.old_form_formData))
        this.$store.commit('updateCurrentFormData', this.form_formData)

        const teamTab =  this.schema.tabs.find(tab => tab.name == 'Team');
        teamTab.side_panel.members.options = this.member_list.filter(x => x.additionalProp1.group == this.selectedGroup.id && x.additionalProp1.subgroup == subgroup.id); 

        var firstItem = teamTab.side_panel.members.options[0];
        if(firstItem) {
            // console.log('2',firstItem)
          this.selectedItemFn(firstItem);
        }
      }
    },
    selectedMemberLocation(val) {
      this.form_formData_locations = val;
      this.$emit('selected-member-location', val);
    },
    selectedMemberGroup(val) {
      this.form_formData_member_group = val;
      this.$emit('selected-member-group', val);
    },
    selectedMemberSubGroup(val) {
      this.form_formData_member_subgroup = val;
      this.$emit('selected-member-subgroup', val);
    },
    deepEqual(object1, object2) {
      if('position' in object1) delete object1['position']
      if('position' in object2) delete object2['position']
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);
      if (keys1.length !== keys2.length) {
        // console.log(keys1)
        // console.log(keys2)
        // console.log('length nm')
        return false;
      }
      for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = this.isObject(val1) && this.isObject(val2);
        if (
          areObjects && !this.deepEqual(val1, val2) ||
          !areObjects && val1 !== val2
        ) {
          return false;
        }
      }
      return true;
    },
    isObject(object) {
      return object != null && typeof object === 'object';
    },
    async selectedItemFn(val) {
      // var temp_old_form_formData = Object.assign({}, this.old_form_formData);
      // delete temp_old_form_formData.active;
      // var temp_form_formData = Object.assign({}, this.form_formData);
      // delete clone.b;

      // this.old_form_formData != JSON.stringify(this.form_formData)

      // console.log(JSON.parse(this.old_form_formData) != this.form_formData)
      // console.log(_.isEqual(JSON.parse(this.old_form_formData), this.form_formData))
      // if(Object.keys(this.old_form_formData).length > 0 && this.form_formData) {
      //   // console.log(this.old_form_formData)
      //   var parsed = JSON.parse(this.old_form_formData)
      //   console.log(parsed)
      //   console.log(this.form_formData)
      //   console.log(this.deepEqual(parsed, this.form_formData));
      // }

      

      // if(this.category.name == 'Info Pages') {
      //   if(this.selectedTab == "Pages") {
      //     this.form_formData.info_box = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].form.info_box.options[0].value;
      //   }
      // }

      // console.log('current', this.currentFormData)
      // console.log('old', this.oldFormData)
      
        // console.log(this.oldFormData);
        // console.log(this.currentFormData);
        // console.log(this.deepEqual(this.oldFormData, this.currentFormData));
        // console.log(this.form_formData.locations != this.form_formData_locations);

      if(Object.keys(this.oldFormData).length && Object.keys(this.currentFormData).length && !this.deepEqual(this.oldFormData, this.currentFormData) && this.category.name != 'Practice Team') {
      // if(this.oldFormData && this.currentFormData && !this.deepEqual(this.oldFormData, this.currentFormData)) {
      // if(Object.keys(this.old_form_formData).length != 0 && JSON.parse(this.old_form_formData).id != val.id && this.old_form_formData !== JSON.stringify(this.form_formData)) {
        // console.log(JSON.parse(this.old_form_formData), this.form_formData)
        Swal.fire({
          title: "You have unsaved changes.",
          text: "Please save your changes before switching to next topic.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Discard changes"
        }).then(async result => {
          if (result.value) {
            this.form_formData = val;
            if(this.category.name == 'Locations') {
              if(this.selectedTab == "Locations") {
              this.form_formData.location_name = val.title;
              this.form_formData.address = val.additionalProp1.address ? val.additionalProp1.address : '';

              let temp_options = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_day.options;
              temp_options = temp_options.map(t => t.id == this.selectedItem.id ? this.oldFormData : t)
              this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_day.options = temp_options;
              }
            }
            if(this.category.name == 'Practice Team') {
              if(this.selectedTab == "Team") {
              this.form_formData.name = val.title;
              // this.form_formData.profile = val.picture;
              this.form_formData.role = val.additionalProp1.role;
              this.form_formData.qualifications = val.additionalProp1.qualifications;
              this.form_formData.gender = val.additionalProp1.gender;
              this.schema.tabs.filter(tab => tab.name == 'Team')[0].form.locations.options = await this.getLocations();
              this.schema.tabs.filter(tab => tab.name == 'Team')[0].form.member_group.options = this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.groups.options;
              this.schema.tabs.filter(tab => tab.name == 'Team')[0].form.member_subgroup.options = this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.subgroups.options ? this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.subgroups.options : [];



              
              this.form_formData.member_group = this.category.additionalProp1.groups.filter(x => x.id == val.additionalProp1.group)[0]
              this.form_formData.member_subgroup = this.form_formData.member_group.subgroups.filter(y => y.id == val.additionalProp1.subgroup)[0] ? this.form_formData.member_group.subgroups.filter(y => y.id == val.additionalProp1.subgroup)[0] : []
              // this.form_formData.member_subgroup = { title: val.additionalProp1.subgroup };

              this.selectedMemberGroup(this.form_formData.member_group);
              this.selectedMemberSubGroup(this.form_formData.member_subgroup);

              // this.form_formData_member_group = { title: val.additionalProp1.group };
              // this.form_formData_member_subgroup = { title: val.additionalProp1.subgroup };

              var filtered = []
              if(this.form_formData.additionalProp1.availability && this.form_formData.additionalProp1.availability.locations) {
                for(const loc of this.form_formData.additionalProp1.availability.locations) {
                  filtered.push(this.schema.tabs.filter(tab => tab.name == 'Team')[0].form.locations.options.filter(x => x.id == loc.id)[0])
                }                   
              }              
              }
              else if(this.selectedTab == "Groups") {
                this.schema.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options = this.category.additionalProp1.groups;
                this.form_formData.name = val.title;
                this.form_formData.subgroups = val.subgroups;
              }
                this.form_formData.locations = filtered;
                this.form_formData_locations = filtered;
            }
            if(this.category.name == 'News') {
              if(this.selectedTab == "News") {
                this.form_formData.date = val.additionalProp1.date;
                this.form_formData.path = val.url;
                console.log('val.additionalProp1.featured');
                console.log(val.additionalProp1.featured);
                if (val.additionalProp1.featured) {
                  this.form_formData.featured = val.additionalProp1.featured;
                } else  {
                  this.form_formData.featured = false
                }
                if (val.additionalProp1.media_type) {
                  this.form_formData.media_type = val.additionalProp1.media_type;
                  this.form_formData.upload_options = val.additionalProp1.media_type;
                }
                // this.form_formData.upload_options = val.additionalProp1.media_type;
                this.form_formData.image_url = val.additionalProp1.image_url;
                this.form_formData.video_url = val.additionalProp1.video_url;

                let temp_options = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_page.options;
                temp_options = temp_options.map(t => t.id == this.selectedItem.id ? this.oldFormData : t)
                this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_page.options = temp_options;
              }
            }
            if(this.category.name == 'Alerts') {
              if(this.selectedTab == "Alerts") {
                // this.form_formData.path = val.additionalProp1.slug ? val.additionalProp1.slug : '';
                this.form_formData.color = val.additionalProp1.color;
                if(val.additionalProp1.further_details && val.additionalProp1.further_details.name) {
                  this.form_formData.further_details = val.additionalProp1.further_details;
                }
                else {
                  this.form_formData.further_details = this.schema.tabs.filter(tab => tab.name == 'Alerts')[0].form.further_details.options[0];  
                }
                this.form_formData.news_item = val.additionalProp1.news_item_id;
                this.form_formData.external_link = val.additionalProp1.news_item_url ? val.additionalProp1.news_item_url : '';

                let temp_options = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_page.options;
                temp_options = temp_options.map(t => t.id == this.selectedItem.id ? this.oldFormData : t)
                this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_page.options = temp_options;
              }
            }
            if(this.category.name == 'Opening Hours') {
              if(this.selectedTab == "Regular Hours") {
              this.schema.tabs.filter(tab => tab.name == "Regular Hours")[0].form.status.options = val.status;

              }
              if(this.selectedTab == "Practice Closure") {
              this.schema.tabs.filter(tab => tab.name == "Practice Closure")[0].form.status.options = val.additionalProp1.status;

              this.form_formData.date = val.title;
              this.form_formData.reduced_hours = val.additionalProp1.reduced_hours;
              this.form_formData.holiday_opening_time = val.additionalProp1.opening_time;
              this.form_formData.holiday_closing_time = val.additionalProp1.closing_time;
              this.form_formData.holiday_second_opening_time = val.additionalProp1.second_opening_time;
              this.form_formData.holiday_second_closing_time = val.additionalProp1.second_closing_time;
              this.form_formData.status = val.additionalProp1.status;
              let temp_options = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.dates.options;
              temp_options = temp_options.map(t => t.id == this.selectedItem.id ? this.oldFormData : t)
              this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.dates.options = temp_options;
              }
            }
            if(this.category.name == 'Info Pages') {
              if(this.selectedTab == "Pages") {
                  this.form_formData.slug = val.additionalProp1.slug;
                  this.form_formData.subtitle = val.additionalProp1.subtitle;
                  this.form_formData.info_box = val.additionalProp1.info_box;
                  this.form_formData.info_title = val.additionalProp1.info_title;
                  this.form_formData.info_description = val.additionalProp1.info_description;
                  this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].form.info_box.options[0].value = val.additionalProp1.info_box;
                  let temp_options = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_page.options;
                  temp_options = temp_options.map(t => t.id == this.selectedItem.id ? this.oldFormData : t)
                  this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_page.options = temp_options;
              }
            }
            if(this.category.name == 'Permissions') {
              if(this.selectedTab == "Permissions") {
                for (const key of Object.keys(val.permissions)) {
                  // this.form_formData.title = val.additionalProp1.name;
                  this.form_formData[key] = val.permissions[key]['READ'];
                }
              }
            }
            this.selectedItem = val;
            this.$emit('selected-item', val);
            this.old_form_formData = JSON.stringify(this.form_formData);

            this.$store.commit('updateOldFormData', JSON.parse(this.old_form_formData))
            this.$store.commit('updateCurrentFormData', this.form_formData)
          }
        });
      }
      else {
        this.form_formData = val;
        if(this.category.name == 'Locations') {
          if(this.selectedTab == "Locations") {
          this.form_formData.location_name = val.title;
          this.form_formData.address = val.additionalProp1.address ? val.additionalProp1.address : '';
          }
        }
        if(this.category.name == 'Practice Team') {
          if(this.selectedTab == "Team") {
          this.form_formData.name = val.title;
          // this.form_formData.profile = val.picture;
          this.form_formData.role = val.additionalProp1.role;
          this.form_formData.qualifications = val.additionalProp1.qualifications;
          this.form_formData.gender = val.additionalProp1.gender;
          this.schema.tabs.filter(tab => tab.name == 'Team')[0].form.locations.options = await this.getLocations();
          this.schema.tabs.filter(tab => tab.name == 'Team')[0].form.member_group.options = this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.groups.options;
          this.schema.tabs.filter(tab => tab.name == 'Team')[0].form.member_subgroup.options = this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.subgroups.options ? this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.subgroups.options : [];

          this.form_formData.member_group = this.category.additionalProp1.groups.filter(x => x.id == val.additionalProp1.group)[0]
          this.form_formData.member_subgroup = this.form_formData.member_group.subgroups.filter(y => y.id == val.additionalProp1.subgroup)[0] ? this.form_formData.member_group.subgroups.filter(y => y.id == val.additionalProp1.subgroup)[0] : []

              this.selectedMemberGroup(this.form_formData.member_group);
              this.selectedMemberSubGroup(this.form_formData.member_subgroup);

          // this.form_formData.member_group = { title: val.additionalProp1.group };
          // this.form_formData.member_subgroup = { title: val.additionalProp1.subgroup };

          // this.form_formData_member_group = { title: val.additionalProp1.group };
          // this.form_formData_member_subgroup = { title: val.additionalProp1.subgroup };

          var filtered = []
          if(this.form_formData.additionalProp1.availability && this.form_formData.additionalProp1.availability.locations) {
            for(const loc of this.form_formData.additionalProp1.availability.locations) {
              filtered.push(this.schema.tabs.filter(tab => tab.name == 'Team')[0].form.locations.options.filter(x => x.id == loc.id)[0])
            }                   
            }
          }
          else if(this.selectedTab == "Groups") {
            this.schema.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options = this.category.additionalProp1.groups;
            this.form_formData.name = val.title;
            this.form_formData.subgroups = val.subgroups;
          }
            this.form_formData.locations = filtered;
            this.form_formData_locations = filtered;
        }
        if(this.category.name == 'News') {
          if(this.selectedTab == "News") {
            this.form_formData.date = val.additionalProp1.date;
            this.form_formData.path = val.url;
            if (val.additionalProp1.featured) {
              this.form_formData.featured = val.additionalProp1.featured;
            } else  {
              this.form_formData.featured = false
            }
            if (val.additionalProp1.media_type) {
              this.form_formData.upload_options = val.additionalProp1.media_type;
              this.form_formData.media_type = val.additionalProp1.media_type;
            }
            this.form_formData.image_url = val.additionalProp1.image_url;
            this.form_formData.video_url = val.additionalProp1.video_url;
          }
        }
        if(this.category.name == 'Alerts') {
          if(this.selectedTab == "Alerts") {
            // this.form_formData.path = val.additionalProp1.slug ? val.additionalProp1.slug : '';
            this.form_formData.color = val.additionalProp1.color;
            if(val.additionalProp1.further_details && val.additionalProp1.further_details.name) {
              this.form_formData.further_details = val.additionalProp1.further_details;
            }
            else {
              this.form_formData.further_details = this.schema.tabs.filter(tab => tab.name == 'Alerts')[0].form.further_details.options[0];  
            }
            this.form_formData.news_item = val.additionalProp1.news_item_id;
            this.form_formData.external_link = val.additionalProp1.news_item_url ? val.additionalProp1.news_item_url : '';
          }
        }
        if(this.category.name == 'Opening Hours') {
          if(this.selectedTab == "Regular Hours") {
          this.schema.tabs.filter(tab => tab.name == "Regular Hours")[0].form.status.options = val.status;

          }
          if(this.selectedTab == "Practice Closure") {
          this.schema.tabs.filter(tab => tab.name == "Practice Closure")[0].form.status.options = val.additionalProp1.status;

          this.form_formData.date = val.title;
          this.form_formData.reduced_hours = val.additionalProp1.reduced_hours;
          this.form_formData.holiday_opening_time = val.additionalProp1.opening_time;
          this.form_formData.holiday_closing_time = val.additionalProp1.closing_time;
          this.form_formData.holiday_second_opening_time = val.additionalProp1.second_opening_time;
          this.form_formData.holiday_second_closing_time = val.additionalProp1.second_closing_time;
          this.form_formData.status = val.additionalProp1.status;
          }
        }
        if(this.category.name == 'Info Pages') {
          if(this.selectedTab == "Pages") {
              this.form_formData.slug = val.additionalProp1.slug;
              this.form_formData.subtitle = val.additionalProp1.subtitle;
              this.form_formData.info_box = val.additionalProp1.info_box;
              this.form_formData.info_title = val.additionalProp1.info_title;
              this.form_formData.info_description = val.additionalProp1.info_description;
              this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].form.info_box.options[0].value = val.additionalProp1.info_box;
          }
        }
        if(this.category.name == 'Permissions') {
          if(this.selectedTab == "Permissions") {
            for (const key of Object.keys(val.permissions)) {
              // this.form_formData.title = val.additionalProp1.name;
              this.form_formData[key] = val.permissions[key]['READ'];
            }
          }
        }
        this.selectedItem = val;
        this.$emit('selected-item', val);
        this.old_form_formData = JSON.stringify(this.form_formData);
            
        this.$store.commit('updateCurrentFormData', this.form_formData)
        this.$store.commit('updateOldFormData', JSON.parse(this.old_form_formData))
      }

      if(this.form_formData) this.$store.commit('updateCurrentFormData', this.form_formData)
    },
    submit(val, side_panel_val) {

      if(this.category.name == 'Info Pages') {
        if(this.selectedTab == "Pages") {
          val.info_box = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].form.info_box.options[0].value;
        }
      }

      if((this.oldFormData && this.currentFormData && !this.deepEqual(this.oldFormData, this.currentFormData) || this.selectedTab == 'Content')) {

        this.old_form_formData = JSON.stringify(val);
        this.form_formData = JSON.parse(this.old_form_formData);
        // this.old_form_formData = JSON.stringify(this.form_formData);
        
        this.$store.commit('updateOldFormData', JSON.parse(this.old_form_formData))
        this.$store.commit('updateCurrentFormData', this.form_formData)

        this.$emit('submit', val, side_panel_val);
      }
      else {
          Swal.fire("Not Updated!", "Please update form and submit again!!", "warning");
      }
    },
    radioChangeFn(key, val) {
      this.form_formData[key] = val;
    },
    radioGenderChangeFn(key, val) {
      this.form_formData[key] = val;
    },
    getNews() {
      api.get(`/api/cms/${this.currentCms.id}/categories`)
      .then((response) => {
        var newsCat = response.data.filter(x => x.name == 'News')[0];
          api.get(`/api/categories/${newsCat.id}/pages`)
          .then((response) => {
            this.location_list = response.data;
            // console.log('news', response)
            // this.page.tabs.filter(tab => tab.name == 'Alerts')[0].form.news_item.options = response.data;
          }, (error) => {
            console.log(error);
          });
      }, (error) => {
        console.log(error);
      });
    },
    async getLocations() {
      return await new Promise((resolve)=>{
        api.get(`/api/cms/${this.currentCms.id}/categories`)
        .then((response) => {
          var locCat = response.data.filter(x => x.name == 'Locations')[0];
            api.get(`/api/categories/${locCat.id}/pages`)
            .then((response) => {
              resolve(response.data)
            }, (error) => {
              console.log(error);
            });
        }, (error) => {
          console.log(error);
        });
      });
    },
    addGroupFn(val) {
      this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.groups.options.push({'title': val});  
      this.$emit('add-group', val);
    },
    addSubGroupFn(val) {
      this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.subgroups.options.push({'title': val});  
      this.$emit('add-subgroup', val);
    },
    removeGroupFn(val) {
      // var filteredArray = this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.groups.options.filter(x => x.title !== val);
      // this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.groups.options = filteredArray;
      this.$emit('remove-group', val);
    },
    removeSubGroupFn(val) {
      // var filteredArray = this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.subgroups.options.filter(x => x.title !== val);
      // this.schema.tabs.filter(tab => tab.name == 'Team')[0].side_panel.subgroups.options = filteredArray;
      this.$emit('remove-subgroup', val);
    },
    toggleChangeFn(key, val) {
      this.form_formData[key] = val;
    }
  },
  watch: {
    updateCurrentFormData: {
      deep: true,
      handler(prevVal, val) {
        this.form_formData = val;
      }
    },
    updateOldFormData: {
      deep: true,
      handler(prevVal, val) {
        this.old_form_formData = val;
      }
    },
    selectedItem: {
      deep: true,

      // We have to move our method to a handler field
      handler(prevVal, val) {
        if(prevVal.id == val.id) {
          var tempActive = JSON.parse(this.old_form_formData)
          tempActive.active = val.active;
          this.old_form_formData = JSON.stringify(tempActive);

        }
      }
    },
    schema: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler(val) {
        if(this.category.name == 'Locations' && this.selectedTab == 'Locations') {
          if(this.list_length != val.tabs[1].side_panel.select_a_day.options.length) {
            this.list_length = val.tabs[1].side_panel.select_a_day.options.length;
            var first_loc = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_day.options[0];
            this.selectedItemFn(first_loc)
          }
        }
        else if(this.category.name == 'Practice Team') {
          if(this.selectedTab == "Team") {
            if(this.list_length != val.tabs[2].side_panel.members.options.length) {
              this.list_length = val.tabs[2].side_panel.members.options.length;
              var first_mem = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.members.options[0];
              this.selectedItemFn(first_mem)
            }
          }
          else if(this.selectedTab == "Groups") {
            if(this.list_length != this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.groups.options.length) {
              this.list_length = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.groups.options.length;
              var first_group = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.groups.options[0];
              this.selectedItemFn(first_group)
            }
          }
        }
        else if(this.category.name == 'Opening Hours') {
          if(this.list_length != val.tabs[2].side_panel.dates.options.length) {
            this.list_length = val.tabs[2].side_panel.dates.options.length;
            var first_date = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.dates.options[0];
            this.selectedItemFn(first_date)
          }
        }
        else {
          if(this.selectedTab != 'Content' && this.list_length != val.tabs[0].side_panel.select_a_page.options.length) {
            this.list_length = val.tabs[0].side_panel.select_a_page.options.length;
            var first_alert = this.schema.tabs.filter(tab => tab.name == this.selectedTab)[0].side_panel.select_a_page.options[0];
            this.selectedItemFn(first_alert)
          }
        }
      }
    }
            // var first_alert = this.schema.tabs.filter(tab => tab.name == "Alerts")[0].side_panel.select_a_page.options[0];
  },
  mounted() {
    this.getNews();
    if(this.selectedTab == '') {
      this.selectedTabFn(this.schema.tabs[0].name);
    }
  }
};
</script>

<template>
    <div class="d-lg-flex" style="letter-spacing: 0.02em;min-height: calc( 100vh - 144px );">
      <div class="chat-leftsidebar w-25 pr-4 pt-3">
        <div v-if="schema.tabs.length > 1">
          <b-tabs nav-class="nav-tabs-custom" content-class="py-3 text-muted">
            <b-tab v-for="tab in schema.tabs" v-bind:key="tab.name" :title="tab.name"
            @click="selectedTabFn(tab.name)">
              <template v-slot:title>
                <span class="d-none d-sm-block">{{tab.name}}</span>
              </template>
              <b-card-text>
                  <simplebar style="max-height: calc(100vh - 200px); padding-right: 2em;" id="scrollElement" data-simplebar-auto-hide="false">
                    <JsonForm :schema="tab.side_panel" :formData="side_panel_formData" :selectedItem="selectedItem" :category="category" @selected-item="selectedItemFn" @selected-location="selectedLocationFn" @selected-group="selectedGroupFn" @selected-subgroup="selectedSubgroupFn"
                     @remove-subgroup="removeSubGroupFn" @add-group="addGroupFn" @remove-group="removeGroupFn" @add-subgroup="addSubGroupFn"></JsonForm>
                  </simplebar>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </div>
        <div v-else>
          <simplebar style="max-height: calc(100vh - 200px); padding-right: 2em;" id="scrollElement" data-simplebar-auto-hide="false">
            <JsonForm :schema="schema.tabs[0].side_panel" :formData="side_panel_formData" :selectedItem="selectedItem" :category="category" @selected-item="selectedItemFn" @selected-location="selectedLocationFn"></JsonForm>
          </simplebar>
        </div>
      </div>
      <div class="w-100 mt-4 mt-sm-0" style="border-left: 1px solid #DADCE3;">

        <div v-if="selectedTab == 'Description' || selectedTab == 'Content' || Object.keys(oldFormData).length && Object.keys(currentFormData).length && form_formData"
        class="pt-3 pl-lg-4" style="letter-spacing: 0.02em;">
          <JsonForm v-if="selectedTab" :schema="schema.tabs.filter(tab => tab.name == selectedTab)[0].form" :formData="form_formData" :category="category" @radio-change="radioChangeFn" @radio-change-gender="radioGenderChangeFn" @toggle-change="toggleChangeFn"
            :form_formData_locations="form_formData_locations" :form_formData_member_group="form_formData_member_group" :form_formData_member_subgroup="form_formData_member_subgroup"
            @selected-member-location="selectedMemberLocation" @selected-member-group="selectedMemberGroup" @selected-member-subgroup="selectedMemberSubGroup"></JsonForm>
          <div class="font-size-14 font-weight-medium d-flex align-items-center justify-content-between mt-4 mb-5 border-right-dark">
            <b-button v-on:click="submit(form_formData, side_panel_formData)" class="px-4" variant="primary">Save</b-button>
          </div>
        </div>
      </div>
    </div>
</template>